import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import Select from 'react-select';
import AdvancedSearchHelper from '../../AdvancedSearchHelper';
import {
  limitSelectOptions,
  casefoldersSelectOptions,
  querySelectOptions,
  regionSelectOptions,
  chapterSelectOptions,
  caseTypeSelectOptions,
  industrySelectOptions,
  assetsLiabilitiesSelectOptions,
  scheduleSelectOptions,
  scheduleCategorySelectOptions,
} from '../../formData';
import FieldSet from '../../../Modules/FieldSet';
import {
  SearchPDFsField,
  CasesField,
  RegionField,
  QueryField,
  CaseTitlesField,
  ChapterField,
  TypeField,
  DatePickerField,
  BusinessOnlyField,
  IndustryField,
  AssetsField,
  LiabilitiesField,
  InputField,
} from '../../fields';

import '../../AdvancedSearch.less';

const SchedulesForm = ({ filter, onSubmit, onReset }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={filter}
    render={({ handleSubmit, form, values }) => (
      <form onSubmit={handleSubmit} className="advanced-search-form">
        <InputField placeholder="Enter Keywords" />
        <AdvancedSearchHelper />
        <div className="advanced-search-filters">
          <FieldSet title="Advanced Filters">
            <div className="form-item form-item-row">
              <div className="col-2">
                <SearchPDFsField limitSelectOptions={limitSelectOptions} />
              </div>
              <div className="col-2">
                <CasesField casefoldersSelectOptions={casefoldersSelectOptions} />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Case Information">
            <div className="form-item form-item-row">
              <div className="col-2">
                <RegionField regionSelectOptions={regionSelectOptions} />
              </div>
              <div className="col-2">
                <QueryField querySelectOptions={querySelectOptions} disabled />
              </div>
            </div>
            <div className="form-item form-item-row">
              <div className="col-2">
                <ChapterField chapterSelectOptions={chapterSelectOptions} />
              </div>
              <div className="col-2">
                <TypeField caseTypeSelectOptions={caseTypeSelectOptions} />
              </div>
            </div>
            <div className="form-item form-item-row">
              <div className="col-2">
                <CaseTitlesField limitSelectOptions={limitSelectOptions} />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Financial Filters">
            <div className="form-item form-item-row">
              <div className="col-2">
                <BusinessOnlyField limitSelectOptions={limitSelectOptions} disabled />
              </div>
              <div className="col-2">
                <IndustryField industrySelectOptions={industrySelectOptions} />
              </div>
            </div>
            <div className="form-item form-item-row">
              <div className="col-2">
                <AssetsField assetsLiabilitiesSelectOptions={assetsLiabilitiesSelectOptions} />
              </div>
              <div className="col-2">
                <LiabilitiesField assetsLiabilitiesSelectOptions={assetsLiabilitiesSelectOptions} />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Schedules Filters">
            <div className="form-item form-item-row">
              <Field name="schedule" parse={({ value }) => value}>
                {({ input }) => (
                  <div className="col-2">
                    <label>Schedule</label>
                    <Select {...input} clearable={false} options={scheduleSelectOptions} className="form-select" />
                  </div>
                )}
              </Field>
              <Field name="schedule_category" parse={({ value }) => value}>
                {({ input }) => (
                  <div className="col-2">
                    <label>Category</label>
                    <Select
                      {...input}
                      clearable={false}
                      options={scheduleCategorySelectOptions}
                      className="form-select"
                      disabled={values.schedule !== 'schedule_ab'}
                    />
                  </div>
                )}
              </Field>
            </div>
            <div className="form-item form-item-row">
              <div className="col-2">
                <label>From</label>
                <Field
                  name="schedule_value_from"
                  component="input"
                  type="text"
                  className="form-input"
                  placeholder="$"
                />
              </div>
              <div className="col-2">
                <label>To</label>
                <Field name="schedule_value_to" component="input" type="text" className="form-input" placeholder="$" />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Date Filters">
            <div className="form-item">
              <label>Cases filed</label>
              <div className="form-item-row">
                <DatePickerField fieldName="date_filed_from" placeholderText="From" />
                <DatePickerField fieldName="date_filed_to" placeholderText="Through" />
              </div>
            </div>
            <div className="form-item">
              <label>Open cases</label>
              <div className="form-item-row">
                <DatePickerField fieldName="open_cases_from" placeholderText="From" />
                <DatePickerField fieldName="open_cases_to" placeholderText="Through" />
              </div>
            </div>
            <div className="form-item">
              <label>Documents filed</label>
              <div className="form-item-row">
                <DatePickerField fieldName="date_doc_filed_from" placeholderText="From" />
                <DatePickerField fieldName="date_doc_filed_to" placeholderText="Through" />
              </div>
            </div>
          </FieldSet>
        </div>
        <div className="action-btn-container">
          <button type="submit" className="btn btn-success btn-search">
            Search
          </button>
          <button
            type="button"
            className="btn btn-link"
            onClick={() => {
              form.reset();
              onReset();
            }}
          >
            Clear
          </button>
        </div>
      </form>
    )}
  />
);

SchedulesForm.propTypes = {
  filter: PropTypes.any.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default SchedulesForm;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/initialForms/bankruptcy/SchedulesForm.jsx